import { startOfWeek } from 'date-fns'
import z from 'zod'

import { contentTypeFiltersSchema } from '@/dialogs/ContentTypeTikTokFiltersDialog/validation.ts'
import { statisticsFilterSchema } from '@/dialogs/StatisticsTikTokFiltersDialog/validation.ts'

export const schema = z.object({
  priority: z.enum(['trending', 'most-views']).optional(),
  countries: z.array(z.string()),
  contentType: contentTypeFiltersSchema.optional(),
  statistics: statisticsFilterSchema.optional(),
  date: z.object({
    from: z.date(),
    to: z.date(),
  }),
})

export type TikTokVideosFiltersForm = z.infer<typeof schema>

export const defaultValues: TikTokVideosFiltersForm = {
  countries: [],
  date: {
    from: startOfWeek(new Date(), { weekStartsOn: 1 }),
    to: new Date(),
  },
}
